import { useState } from "react";
import { MdListAlt } from "react-icons/md";

export default function RequestQuoteContent() {
  const [formData, setFormData] = useState({
    fullName: "",
    company: "",
    emailOrPhone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent("Request a Quote from Group V Limited");
    const body = encodeURIComponent(
      `Full Name: ${formData.fullName}\n` +
      `Company / Project: ${formData.company}\n` +
      `Email / Phone: ${formData.emailOrPhone}\n` +
      `Message / Material Request:\n${formData.message}`
    );
    window.location.href = `mailto:sales@groupv.co.tz?subject=${subject}&body=${body}`;
  };

  return (
    <section className="request-quote py-5">
      <div className="container mt-5" style={{ maxWidth: 700 }}>
        <p className="text-center text-primary mb-4 font-bold" style={{fontSize:"24px"}}>Request a Quote</p>

        <form onSubmit={handleSubmit} className="quote-form p-2 p-md-3">
          <div className="">
            <label className="text-surface form-label fw-semibold">Full Name</label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              className="form-control form-control-lg"
              placeholder="Enter your full name"
              required
            />
          </div>

          <div className="mt-2">
            <label className="text-surface form-label fw-semibold">Company / Project Name</label>
            <input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              className="form-control form-control-lg"
              placeholder="Company or project name"
              required
            />
          </div>

          <div className="mt-2">
            <label className="text-surface form-label fw-semibold">Email / Phone</label>
            <input
              type="text"
              name="emailOrPhone"
              value={formData.emailOrPhone}
              onChange={handleChange}
              className="form-control form-control-lg"
              placeholder="Email address or phone number"
              required
            />
          </div>

          <div className="mt-2">
            <label className="text-surface form-label fw-semibold">Message / Material Request</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="form-control"
              placeholder="Describe your requirements..."
              rows={6}
              required
            ></textarea>
          </div>

          <div className="text-center mt-3">
            <button
              type="submit"
              className="btn btn-primary btn-lg d-inline-flex align-items-center gap-2 px-5"
            >
              <MdListAlt size={22} />
              Submit Request
            </button>
          </div>
        </form>
      </div>

      <style>{`
        .request-quote {
          background: #f9fafb;
          font-family: Inter, system-ui, sans-serif;
        }
        .quote-form {
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(0,0,0,.06);
        }
        .form-label {
          font-size: 15px;
          margin-bottom: 6px;
        }
        .form-control {
          border-radius: 10px;
          padding: 12px 16px;
          font-size: 15px;
        }
        .btn-primary {
          background: #0f766e;
          border: none;
          font-weight: 600;
          border-radius: 999px;
          padding: 12px 30px;
          cursor: pointer;
        }
        .btn-primary:hover {
          background: #11574f;
        }
      `}</style>
    </section>
  );
}